module.exports = __webpack_public_path__ + "public/files/img/tasks.b6aaa8cc.png";